import { useEffect } from 'react'
import uiStore from '../stores/uiStore'
import Auth from '../utils/auth'
import { routes } from '../utils/constants'
import { useSubdomain } from '../hooks/useSubdomain'

const Logout = () => {
  const subdomain = useSubdomain()

  useEffect(() => {
    uiStore.setLoadingScreenMessage('Logging out')
    Auth.logUserOut()

    setTimeout(() => {
      window.location.href = !!subdomain ? '/' : routes.LANDING
    }, 300)
  }, [subdomain])

  return null
}

export default Logout
